import mutations from './insurancePartner.mutations'
import actions from './insurancePartner.actions'
import getters from './insurancePartner.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
